import {CheckOutlined} from '@ant-design/icons'
import {Col, Form, Input, Row, Select, Space} from 'antd'
import {useForm} from 'antd/es/form/Form'
import * as React from 'react'
import {useContext, useEffect, useState} from 'react'
import {useHistory} from 'react-router'

import {SITES_LIST_PATH} from 'constants/routes'

import {UserContext} from 'utils/userContext.tsx'

import {CustomButton} from 'components/customButton/CustomButton'

import {ArchiveButtonPopConfirm} from 'pages/site/ArchiveButtonPopConfirm'

import 'pages/site/siteForm.scss'
import {SiteInfoBean} from "api/base/api.ts"

const { Option } = Select

interface Props {
  siteInfoBean?: SiteInfoBean
  showArchiveButton?: boolean
  handleSubmit: (form: any, protocol: string) => void
  handleArchive?: (e: any) => void
  submitButtonName: string
}

export const SiteForm: React.FC<Props> = ({
  siteInfoBean,
  showArchiveButton,
  handleSubmit,
  handleArchive,
  submitButtonName,
}) => {
  const { fullAccess } = useContext(UserContext)

  const history = useHistory()

  const [form] = useForm()
  const formLayout = {
    labelCol: {
      xs: { span: 12 },
      sm: { span: 6 },
      lg: { span: 4 },
      xl: { span: 3 },
      xxl: { span: 2 },
    },
    wrapperCol: {
      xs: { span: 12 },
      sm: { span: 14 },
      lg: { span: 16 },
      xl: { span: 17 },
      xxl: { span: 18 },
    },
  }

  const [protocol, setProtocol] = useState('http://')
  const domainInitialValue = siteInfoBean?.domain?.includes('https://')
    ? siteInfoBean?.domain?.substring(8)
    : siteInfoBean?.domain?.includes('http://')
    ? siteInfoBean?.domain?.substring(7)
    : siteInfoBean?.domain

  const selectBefore = (
    <Select
      defaultValue={siteInfoBean ? (siteInfoBean.domain?.includes('https://') ? 'https://' : 'http://') : 'http://'}
      className="select-before"
      onChange={setProtocol}
    >
      <Option value="http://">http://</Option>
      <Option value="https://">https://</Option>
    </Select>
  )

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => form.resetFields(), [siteInfoBean])

  return (
    <div className="site-form__form">
      <Form
        form={form}
        {...formLayout}
        initialValues={{
          name: siteInfoBean?.name,
          domain: domainInitialValue,
          description: siteInfoBean?.description
        }}
        onFinish={(form) => handleSubmit(form, protocol)}
      >
        <Form.Item
          name="name"
          label="Site Name"
          style={{ marginBottom: 16 }}
          rules={[
            {
              required: true,
              message: 'Please enter Site Name',
            },
          ]}
        >
          <Input placeholder="Site Name" />
        </Form.Item>

        <Form.Item
          name="domain"
          label="Domain"
          rules={[
            {
              required: true,
              message: 'Please enter Domain',
            },
          ]}
          style={{ marginBottom: 16 }}
        >
          <Input addonBefore={selectBefore} placeholder="domain.com" />
        </Form.Item>

        <Form.Item name="description" label="Description" style={{ marginBottom: 16 }}>
          <Input.TextArea placeholder="Notes" />
        </Form.Item>

        <Row align="stretch">
          <Col xs={12} sm={6} lg={4} xl={3} xxl={2} />
          <Col span={8}>
            <Space>
              <CustomButton disabled={!fullAccess} type={fullAccess ? 'primary' : 'disabled'} icon={<CheckOutlined />}>
                {submitButtonName}
              </CustomButton>
              <CustomButton type="bordered" onClick={() => history.push(SITES_LIST_PATH)}>
                Cancel
              </CustomButton>
            </Space>
          </Col>
          <Col style={{ textAlign: 'right' }}>
            {showArchiveButton && fullAccess && (
              <Space>
                <ArchiveButtonPopConfirm
                  handleArchive={handleArchive as (e: any) => void}
                  id={siteInfoBean?.id as number}
                />
              </Space>
            )}
          </Col>
        </Row>
      </Form>
    </div>
  )
}
